/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { ModalStyled } from './ModalStyled';
import { IC_CONSENT_IMAGE } from '../../../../public/images';
import Image from 'next/image';

const CustomModal = (props) => {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
  const seconderyButtonClcked = () => {
    if(props?.seconderyButtonClcked()){
    props?.seconderyButtonClcked();
    handleClose();
    }
  };
  const primaryButtonClicked = (e) => {
    props?.primaryButtonClicked(e);
  };
  const dangerButtonClicked = () => {
    props?.dangerButtonClicked();
  };
  const onCancelClicked = () => {
    props?.cancelButtonClicked();
  };

  return (
    <ModalStyled className={props?.outerCustomClass}>
      <Modal
        className={props.customClass}
        show={show}
        centered
        backdropClassName="modalBackDropStyled"
        dialogClassName="modalDialogStyled"
        onHide={props?.crossPressed}
        backdrop="static"
        keyboard={false}
        size={props?.size}
        noFooter={props?.noFooter}
        contentMaxHeight={props?.contentMaxHeight}
        fullscreen={props?.fullscreen}
      >
        {props?.modalTitle && (
          <Modal.Header closeButton={props?.closeButton}>
            <Modal.Title className={`${props?.titleLeftAligned ? 'text-left' : ''} ${props?.titleRightAligned ? 'text-end' : ''}`}>{props?.modalTitle}</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body
          style={{ maxHeight: props?.contentMaxHeight, overflow: 'auto' }}
          className={`${props.bodyTextCenter && 'text-center'} ${props?.modalFrom === 'homeCareModal' && 'homecare'}`}
        >
          {props.children}
        </Modal.Body>
        {props?.noFooter === false && (
          <Modal.Footer
            className={
              props?.modalFrom === 'homeCareModal'
                ? ` ${props?.footerAlignment} ${props?.footerBtnFullWidth} ${props?.btnFullWidth} homecare`
                : `justify-content-${props?.footerAlignment} ${props?.footerBtnFullWidth && 'flex-nowrap'} ${
                    props?.btnFullWidth && 'flex-wrap'
                  }`
            }
          >
            {props?.secondaryButtonText && (
              <Button
                data-testid="SecondaryButton"
                className={`${props.footerBtnFullWidth && 'w-100'} ${props.btnFullWidth && 'w-100 mt-3'} ${
                  props.secondaryButtonOrder && `order-${props.secondaryButtonOrder}`
                }`}
                variant={`secondary ${props?.outerCustomClass}`}
                onClick={() => {
                  seconderyButtonClcked();
                }}               
              >
                {props?.secondaryButtonText}
              </Button>
            )}
            {props?.dangerButtonText && (
              <Button
                data-testid="DangerButton"
                className={`${props.footerBtnFullWidth && 'w-100'} ${props.btnFullWidth && 'w-100 mt-3'} ${
                  props.dangerButtonOrder && `order-${props.dangerButtonOrder}`
                }`}
                variant="danger"
                onClick={() => {
                  handleClose();
                  dangerButtonClicked();
                }}
              >
                {props?.dangerButtonText}
              </Button>
            )}
            {props?.primaryButtonText && (
              <Button
                data-testid="PrimaryButton"
                className={`${props.footerBtnFullWidth && 'w-100'} ${props.btnFullWidth && 'w-100 mt-3'} ${
                  props.primaryButtonOrder && `order-${props.primaryButtonOrder}`
                }`}
                variant={`primary ${props?.outerCustomClass}`}
                onClick={primaryButtonClicked}
              >
                {props?.consentForm ? (
                  <div className="Consent-Form">
                    <div className="fileName" onClick={props?.consentFormLink}>
                      <div className="icon">
                        <Image src={IC_CONSENT_IMAGE.src} alt={'consent Image'} width="24px" height="18px" />
                      </div>
                      <div className="name">ConsentForm.pdf</div>
                    </div>
                    <div className="downloadBtn" onClick={props?.consentFormDownload}>
                      {props?.primaryButtonText}
                    </div>
                  </div>
                ) : (
                  props?.primaryButtonText
                )}
              </Button>
            )}

            {props?.cancelButton && (
              <Button
                data-testid="cancelButton"
                className={`${props.footerBtnFullWidth && 'w-100'} ${props.btnFullWidth && 'w-100 mt-3'} ${
                  props.cancelButtonOrder && `order-${props.cancelButtonOrder}`
                } text-decoration-none`}
                variant={`link ${props?.outerCustomClass}`}
                onClick={onCancelClicked}
              >
                {props?.modalFrom === 'homeCareModal' ? 'Close' : 'Cancel'}
              </Button>
            )}
          </Modal.Footer>
        )}
      </Modal>
    </ModalStyled>
  );
};

CustomModal.propTypes = {
  customClass: PropTypes.string,
  outerCustomClass: PropTypes.string,
  children: PropTypes.any,
  closeButton: PropTypes.bool,
  modalTitle: PropTypes.string,
  bodyTextCenter: PropTypes.bool,
  footerAlignment: PropTypes.string,
  footerBtnFullWidth: PropTypes.bool,
  primaryButtonText: PropTypes.string,
  dangerButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  size: PropTypes.string,
  noFooter: PropTypes.bool,
  crossPressed: PropTypes.any,
  cancelButton: PropTypes.bool,
  btnFullWidth: PropTypes.bool,
  fullscreen: PropTypes.bool,
  primaryButtonOrder: PropTypes.string,
  secondaryButtonOrder: PropTypes.string,
  dangerButtonOrder: PropTypes.string,
  cancelButtonOrder: PropTypes.string,
  primaryButtonClicked: PropTypes.func,
  titleLeftAligned: PropTypes.bool,
  titleRightAligned: PropTypes.bool,
  contentMaxHeight: PropTypes.string,
  modalFrom: PropTypes.string,
  consentForm: PropTypes.bool,
  consentFormDownload: PropTypes.any,
  consentFormLink: PropTypes.any,
};
CustomModal.defaultProps = {
  customClass: '',
  outerCustomClass: '',
  children: '',
  size: 'lg',
  closeButton: false,
  modalTitle: '',
  bodyTextCenter: false,
  footerAlignment: 'center',
  footerBtnFullWidth: false,
  btnFullWidth: false,
  primaryButtonText: '',
  dangerButtonText: '',
  secondaryButtonText: '',
  noFooter: false,
  cancelButton: false,
  fullscreen: false,
  primaryButtonOrder: '3',
  secondaryButtonOrder: '1',
  dangerButtonOrder: '2',
  cancelButtonOrder: '4',
  titleLeftAligned: false,
  titleRightAligned: false,
};
export default CustomModal;
